<template>
  <div class="switch" @click="changeSwitch" :class="{'active':checkSwitch}"></div>
</template>

<script>
  export default {
    name: 'my-switch',
    data () {
      return {
   
      }
    },
    props: {
      checkSwitch: {
        type: Boolean,
        default: () => false
      },
    },
    watch: {

    },
    computed: {},
    created () {
    },
    mounted () {
    },
    methods: {
      changeSwitch (val) {
        this.$emit('change-switch', val)
      }

    }

  }
</script>

<style lang="scss" scoped>
.switch{
  width: 82px;
  height: 44px;
  display: inline-block;
  background: url("/images/public/switch.png") no-repeat left center;
  background-size: 100%;
  transition: .3s;
}
.switch.active{
  background-image: url("/images/public/switch_active.png");
}
</style>
